import styled from 'styled-components';
import { Typography } from '../../typography';
import { selectThemeSemantics } from '../../../styling';

export const CheckboxLabel = styled(Typography.Medium).attrs({
    className: String('ap-checkbox-label')
}) <{ $disabled?: boolean; $required?: boolean; }>`
    padding-left: ${selectThemeSemantics(({ gap }) => gap.l)};
    vertical-align: middle;
    opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};

    &:after {
        content: ${({ $required }) => ($required ? '\'*\'' : '')};
        color: ${selectThemeSemantics(({ palette }) => palette.red)};
    }
`;
